const singleColumn = () => {
  setBgPosition();

  addEventListener('resize', () => {
    setBgPosition();
  });

  const index = document.querySelector('.p-column-index');
  const indexHeader = document.querySelector('.p-column-index__header');
  const indexBody = document.querySelector('.p-column-index__body');
  const entry = document.querySelector('.p-column-item__entry');
  /**
   * 目次の展開
   */
  indexHeader.addEventListener('click', () => {
    $(indexBody).slideToggle();
  });

  /**
   * 目次の生成
   */
  const entryList = entry.querySelectorAll('h2, h3, h4');
  if (entryList.length) {
    entryList.forEach((entry, index) => {
      let entryId = entry.id;
      if (entryId == '') {
        entryId = `entry-${index}`;
        entry.setAttribute('id', entryId);
      }
      const entryLink = document.createElement('a');
      entryLink.setAttribute('href', `#${entryId}`);
      if (entry.tagName === 'H2') {
        entryLink.setAttribute('data-index', '1');
      } else if (entry.tagName === 'H3') {
        entryLink.setAttribute('data-index', '2');
      } else if (entry.tagName === 'H4') {
        entryLink.setAttribute('data-index', '3');
      }
      entryLink.textContent = entry.textContent;
      indexBody.appendChild(entryLink);
    });
  }
};

const setBgPosition = () => {
  // パンくずのHTMLを取得
  const breadcrumbHTML = document.getElementById('breadcrumb');
  // パンクスの高さを取得
  const breadcrumbHeight = breadcrumbHTML.clientHeight;
  // site-bodyを取得
  const siteBody = document.querySelector('.site-body');
  // site-bodyに余白を設定
  siteBody.setAttribute('style', `margin-top: ${-breadcrumbHeight}px !important; padding-top: ${breadcrumbHeight + 30}px !important;`);
};

export default singleColumn;
